
//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :
import Background from '../../components/background/Background.jsx'
import ProgressBar from '../../components/progressbar/ProgressBar.jsx'
import WallyBanner from '../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />
//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { elevesSlice } from "../../store/elevesSlice.js";
import { clientSlice } from "../../store/clientSlice.js";
import { getClient, getEleves } from "../../store/selectors.js";

//config
import { listFidelite, listNiveau } from "../../config/niveau-fidelite-config.js";

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

//import MUI
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';


//Utils 
import elevesSorter from '../../utils/eleves_sorter.js';

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)


function Eleves() { // full page as component imported in router

    const dispatch = useDispatch();
    const navigate = useNavigate();

    let reduxEleves = useSelector(getEleves);
    let allEleves = elevesSorter(reduxEleves);


    let theClient = useSelector(getClient);
    const lang = useSelector(getLang) //global state : language

    let listAge = [];
    for (let i = 1; i <= 99; i++) { listAge.push(i); }



    //// -- at first render :
    useEffect(() => {


        //security : redirect
        if (Object.keys(theClient).length === 0) {
            navigate("../");
        }



        // load formules from DB
        async function initEleves() { //we add this inner function to manage asynchrone
            let listEleves = await getEleves();
            let formattedList = [];

            listEleves.map((eleve) => {
                formattedList.push({
                    id: eleve.id_eleve,
                    prenom: eleve.prenom,
                    age: eleve.age,
                    niveau: eleve.niveau_id,
                    fidelite: eleve.fidelite_id,
                    checked: false
                });
            });


            if (allEleves.length === 0) { //just on first tour
                dispatch(elevesSlice.actions.initEleves(formattedList));
            }
        } //end of async function


        if (theClient.id_client > 0) {
            initEleves(); //call the inner asnchrone function
        }
        else {
            //// -- if new client, allEleves is not initialized, so we add first eleve
            if (allEleves.length < 1) {
                console.log("id client", theClient.id_client);
                dispatch(elevesSlice.actions.initEleves({
                    prenom: "",
                    age: 0,
                    niveau: 1,
                    fidelite: 1,
                    checked: true,
                    id: -1
                }));
            }
        }

        async function getEleves() { // get list of formules from DB

            try {
                const response = await axios({
                    method: 'GET',
                    url: baseURL + `/eleve/client/${theClient.id_client}`,
                });
                //console.log(response.data.data);
                const eleves = response.data.data;
                return eleves;
            } catch (err) {
                console.error(err);
                return null;
            }
        }

    }, [theClient])
    //// -- 





    function handleChangeEleve(value, eleve, attribut) {

        let eleveModif = {
            age: attribut === "age" ? value : eleve.age,
            prenom: attribut === "prenom" ? value : eleve.prenom,
            niveau: attribut === "niveau" ? value : eleve.niveau,
            fidelite: attribut === "fidelite" ? value : eleve.fidelite,
            checked: attribut === "check" ? value : eleve.checked,
            id: eleve.id
        }
        dispatch(elevesSlice.actions.modifyEleve(eleveModif));

    }

    function addEleve() {

        dispatch(elevesSlice.actions.addEleve({
            prenom: "",
            age: 0,
            niveau: 1,
            fidelite: 1,
            checked: true,
            id: getNewId()
        }));
    }

    function getNewId() {
        let newList = allEleves.toSorted((e1, e2) => e1.id > e2.id ? 1 : -1);
        let baseId = newList[0].id;
        let newId = baseId > 0 ? -1 : baseId - 1;
        return newId;

    }

    function verifNext() {
        let bool = false;
        let zero = true;

        allEleves.map((eleve) => {
            if (eleve.checked === true) { zero = false; }
            if (eleve.checked === true && (eleve.prenom.length === 0 || eleve.age === 0)) { bool = true; }
        });

        return (bool || zero);
    }




    return (
        <div className="bg-relative">
            <Background ind={1} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner />

                    <div className="main-progress-bar">
                        <ProgressBar currentStep={2} total={5} />
                    </div>

                    <div className="eleves-selection">
                        {theClient.id_client > 0 ?
                            <div className="eleves-selection-intro">
                                <p>Bonjour <span className="eleves-selection-intro-highlight">{theClient.prenom + " " + theClient.nom}</span>, {translator("Merci de nous rendre visite à nouveau :-)", lang, "eleves1")}</p>
                                <p>{translator("Vous avez déjà réservé des cours de surf chez Wally Glisse avec ces élèves :", lang, "eleves2")}</p>
                            </div>
                            : null}

                        <div className="eleves-selection-existing">
                            <h3>{translator("Liste des élèves", lang, "eleves3")}</h3>
                            {allEleves.length > 0 && allEleves.map((eleve) => (
                                /* eleve.id > 0 ? */
                                <div key={eleve.id} className="eleves-selection-existing-line">
                                    <div className="eleves-selection-existing-line-start">

                                        {eleve.id > 0 ?
                                            <h3 className="eleves-selection-existing-line-prenom eleves-selection-existing-line-prenom-fixe" onClick={_ => handleChangeEleve(!eleve.checked, eleve, "check")}>{eleve.prenom}</h3>
                                            :
                                            <TextField

                                                className="eleves-selection-existing-line-prenom"
                                                label={translator("Prénom", lang, "formInfosPrenom")}
                                                size="small"
                                                disabled={eleve.checked === false}
                                                value={eleve.prenom}
                                                error={eleve.prenom.length === 0}
                                                onChange={(e) => handleChangeEleve(e.target.value, eleve, "prenom")}
                                            />
                                        }


                                        <FormControl >
                                            <InputLabel id="label-age">Age</InputLabel>
                                            <Select
                                                className="eleves-selection-existing-line-age"
                                                labelId="label-age"
                                                label="Age"
                                                disabled={eleve.checked === false}
                                                value={eleve.age}
                                                error={eleve.age === 0}
                                                size="small"
                                                variant="outlined"
                                                onChange={(e) => handleChangeEleve(e.target.value, eleve, "age")}
                                            >{
                                                    listAge.map((age) => (
                                                        <MenuItem key={age} value={age}>{age}</MenuItem>
                                                    ))
                                                }

                                            </Select>
                                        </FormControl>

                                    </div>
                                    <div className="eleves-selection-existing-line-middle">

                                        <FormControl>
                                            <InputLabel id="label-niveau">{translator("Niveau surf", lang, "elevesInput1")}</InputLabel>
                                            <Select

                                                className="eleves-selection-existing-line-niveau"
                                                labelId="label-niveau"
                                                label="Niveau surf"
                                                disabled={eleve.checked === false}
                                                value={eleve.niveau}
                                                size="small"
                                                variant="outlined"
                                                onChange={(e) => handleChangeEleve(e.target.value, eleve, "niveau")}
                                            >{
                                                    listNiveau.map((niveau) => (
                                                        <MenuItem key={niveau.id} value={niveau.id}>{niveau.intitule}</MenuItem>
                                                    ))
                                                }

                                            </Select>
                                        </FormControl>

                                        <FormControl>
                                            <InputLabel id="label-fidelite">{translator("Fidélité", lang, "elevesInput2")}</InputLabel>
                                            <Select

                                                className="eleves-selection-existing-line-fidelite"
                                                labelId="label-fidelite"
                                                label="Fidélité"
                                                disabled={eleve.checked === false}
                                                value={eleve.fidelite}
                                                size="small"
                                                variant="outlined"
                                                onChange={(e) => handleChangeEleve(e.target.value, eleve, "fidelite")}
                                            >{
                                                    listFidelite.map((fidelite) => (
                                                        <MenuItem key={fidelite.id} value={fidelite.id}>{fidelite.intitule}</MenuItem>
                                                    ))
                                                }

                                            </Select>
                                        </FormControl>

                                    </div>

                                    <FormControlLabel
                                        className="eleves-selection-existing-line-check"
                                        control={<Checkbox />}
                                        checked={eleve.checked}
                                        label={"élève présent"}
                                        onChange={(event) => handleChangeEleve(event.target.checked, eleve, "check")}
                                    />

                                </div>
                                /*  :
                                 <div className="eleves-selection-new">
                                     <p>{eleve.id}</p>
                                     <TextField
                                         className="eleves-selection-new-prenom"
                                         label="Prénom"
                                         size="small"
                                         value={eleve.prenom}
                                         error={eleve.prenom.length === 0}
                                         
                                         disabled={eleve.id > 0}
                                         onChange={(e) => handleChangeEleve(e.target.value, eleve, "prenom")}
                                     /> 

                                 </div>*/
                            )
                            )}
                        </div>

                        <div className="eleves-selection-ajout">
                            {theClient.id_client > 0 ?
                                <p className="eleves-selection-ajout-infos">
                                    {translator("Cochez les élèves pour qui vous voulez réserver à nouveau", lang, "elevesCoche")}<br />{translator("ou", lang, "elevesOu")}
                                </p>
                                : null}
                            <Button
                                className="eleves-selection-ajout-bouton"
                                onClick={_ => addEleve()}
                                variant="contained">
                                {translator("Ajouter un nouvel élève", lang, "elevesNew")}
                            </Button>
                        </div>
                    </div>


                    <div className="bottom-nav">
                        <Button
                            className="bottom-nav-prev"
                            onClick={_ => navigate("../startresa")}
                            variant="contained">
                            <SkipPreviousIcon />{translator("Précédent", lang, "BtPrevious")}
                        </Button>

                        <Button
                            className="bottom-nav-next"
                            onClick={_ => navigate("../calendar")}
                            variant="contained"
                            disabled={verifNext()}>
                            {translator("Suivant", lang, "BtNext")} <SkipNextIcon />
                        </Button>
                    </div>

                </div>

            </main>
        </div >
    );
}

export default Eleves;